import ButtonT from '@components/tailwind-components/Button/ButtonT';
import { useModal } from '@hooks/modal/useModal';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import { useFacebookPages } from '../../../../hooks/settings/facebook/useFacebookPages';
import { useFacebookPagesActions } from '../../../../hooks/settings/facebook/useFacebookPagesActions';
import { useFacebookSettingsForm } from '../../../../hooks/settings/facebook/useFacebookSettingsForm';
import { useUiState } from '../../../../hooks/useUIState';
import WebclientInputGroup from '../webclient/WebclientInputGroup';
import FacebookErrorModal from './FacebookErrorModal';
import FacebookPersistentMenuList from './persistent-menu/FacebookPersistentMenuList';

export const FacebookSettingsModal: React.FC = () => {
  const { facebookPageSettings } = useFacebookPages();
  const { getSelectedFacebookPageSettings } = useFacebookPagesActions();
  const { onSubmit, control } = useFacebookSettingsForm();
  const { t } = useTranslation();
  const { hideModal } = useModal();

  const { isLoading } = useUiState();

  if (isLoading) {
    return null;
  }

  return facebookPageSettings ? (
    <form className='tailwind-modal-form' onSubmit={onSubmit}>
      <div className='tailwind-modal-body pr-2'>
        <WebclientInputGroup
          title={t('settings.facebook.persistent-menu.title')}>
          <FacebookPersistentMenuList control={control} />
        </WebclientInputGroup>
      </div>
      <div className='tailwind-modal-footer'>
        <ButtonT
          type='button'
          styling='cancel'
          size='xs'
          rounding='md'
          onClick={hideModal}>
          {t('general.buttons.cancel')}
        </ButtonT>
        <ButtonT type='submit' styling='primary' size='xs' rounding='md'>
          {t('general.buttons.save')}
        </ButtonT>
      </div>
    </form>
  ) : (
    <FacebookErrorModal retry={() => getSelectedFacebookPageSettings()} />
  );
};

export default FacebookSettingsModal;
